module.exports = __webpack_public_path__ + "img/light-f-fm-Path 48@3x.12909589.png";